// filepath: apps/web/src/features/admin/tier/TierPanelRoute.tsx
//
// FR-UI-ADM-14 — route shell for the Tier & Quota admin panel.
//
// URL: /admin/tier
//
// The route shell:
//   - resolves the active locale from i18n;
//   - renders the TierPanelPage with the resolved locale.
//
// The page sources `tenantSlug` from the TenantProvider context
// internally (mirroring the fieldVisibility module — the route
// shell stays minimal and does NOT re-export tenant context).
//
// The route does NOT gate on environmentKind — the tier panel is
// read-only and visible in all environments (staging + production)
// so on-call engineers can view live quotas during an incident.
// The AuthGuard wrapper in App.tsx covers authentication.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";
import { TierPanelPage } from "./TierPanelPage";

/**
 * TierPanelRoute — read-only viewer shell for FR-UI-ADM-14.
 * Parses nothing from the URL (the panel has no resource id);
 * renders the page with the active locale from i18n.
 */
export function TierPanelRoute(): React.ReactElement {
  const { locale } = useTranslation();
  return <TierPanelPage locale={locale} />;
}
